module.exports = __webpack_public_path__ + "static/vg-b142c10005e5a69ce079192cd69eb8cb.svg";